import React from 'react';

interface IProps {
  className?: string;
  title: React.ReactElement | string;
  content?: React.ReactElement | string;
}

export const HeaderCopy: React.FC<IProps> = ({ className, title, content }) => (
  <div className={`flex-col text-neutral-800 ${className}`}>
    <h2 className='mb-4 text-3xl font-bold'>{title}</h2>
    {content && <span className='text-lg font-normal'>{content}</span>}
  </div>
);
